export default "__VITE_ASSET__BL$ULSqw__"